export const SENDBOARD_EDITOR_HASH = 'sendboard/editor/';
export const SENDBOARD_LOCATION_HASH = '#/sendboard';
export const URL_TEMPLATE_EDITOR = 'templates/editor';
export const BILLING_BASE = '#/billing';
export const SENDBOARD_UPLOAD = '#/sendboard/upload/';
